"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modeReducerForAutoSegmentation = exports.modeReducerForRectBoxEditor = void 0;
var modeReducerForRectBoxEditor = function (mode, // Modeから'readonly'を除いたもの
action) {
    switch (action) {
        case 'spaceKey-down':
            // スペースキーが押されたら画像移動モードに
            // ただし編集中やウィンドウリサイズ中ならモードを変えない
            switch (mode) {
                case 'rectbox-editor-standby':
                case 'move-image-standby':
                case 'resize-window':
                    return 'move-image-standby';
                default:
                    return mode;
            }
        case 'spaceKey-up':
            // スペースキーを離したら`standby`に戻る
            // ただし編集中やウィンドウリサイズ中ならモードを変えない
            switch (mode) {
                case 'rectbox-editor-standby':
                case 'move-image-standby':
                case 'resize-window':
                    return 'rectbox-editor-standby';
                default:
                    return mode;
            }
        case 'paint-object-click':
        case 'bbox-face-click':
        case 'background-click':
            // 背景がクリックされたとき
            switch (mode) {
                case 'rectbox-editor-standby':
                    return 'rectbox-editor-add-bbox';
                case 'move-image-standby':
                    return 'move-image-dragging';
                default:
                    return mode;
            }
        case 'bbox-point-click':
        case 'bbox-edge-click':
            // bounding-boxがクリックされたとき
            switch (mode) {
                case 'rectbox-editor-standby':
                    return 'rectbox-editor-resize-bbox';
                case 'move-image-standby':
                    return 'move-image-dragging';
                default:
                    return mode;
            }
        case 'mouse-up':
            // マウスを離したとき
            switch (mode) {
                case 'rectbox-editor-add-bbox':
                case 'rectbox-editor-resize-bbox':
                    return 'rectbox-editor-standby';
                case 'move-image-dragging':
                    return 'move-image-standby';
                default:
                    return mode;
            }
        // ポインタが画面内外に出入りしたら`standby`に戻る
        case 'mouse-leave':
        case 'mouse-enter':
        case 'window-resize':
            return 'rectbox-editor-standby';
    }
};
exports.modeReducerForRectBoxEditor = modeReducerForRectBoxEditor;
var modeReducerForAutoSegmentation = function (mode, // Modeから'readonly'を除いたもの
action) {
    switch (action) {
        case 'spaceKey-down':
            // スペースキーが押されたら画像移動モードに
            // ただし編集中やウィンドウリサイズ中ならモードを変えない
            switch (mode) {
                case 'auto-segmentation-standby':
                case 'move-image-standby':
                case 'resize-window':
                    return 'move-image-standby';
                default:
                    return mode;
            }
        case 'spaceKey-up':
            // スペースキーを離したら`standby`に戻る
            // ただし編集中やウィンドウリサイズ中ならモードを変えない
            switch (mode) {
                case 'auto-segmentation-standby':
                case 'move-image-standby':
                case 'resize-window':
                    return 'auto-segmentation-standby';
                default:
                    return mode;
            }
        case 'paint-object-click':
        case 'bbox-point-click':
        case 'bbox-edge-click': // auto-segmentationモードではbboxは無視
        case 'bbox-face-click':
        case 'background-click': // 背景がクリックされたとき
            switch (mode) {
                case 'auto-segmentation-standby':
                    return 'auto-segmentation-crop';
                case 'move-image-standby':
                    return 'move-image-dragging';
                default:
                    return mode;
            }
        case 'mouse-up':
            // マウスを離したとき
            switch (mode) {
                case 'auto-segmentation-crop':
                    return 'auto-segmentation-standby';
                case 'move-image-dragging':
                    return 'move-image-standby';
                default:
                    return mode;
            }
        // ポインタが画面内外に出入りしたら`standby`に戻る
        case 'mouse-leave':
        case 'mouse-enter':
        case 'window-resize':
            return 'auto-segmentation-standby';
    }
};
exports.modeReducerForAutoSegmentation = modeReducerForAutoSegmentation;
